
import * as React from "react";
import {TemplateManager} from "./templateManager/TemplateManager";
import {BasicDialog} from "./utils/Dialogs/BasicDialog";
import {Builder} from "./pagebuilder/Builder";
import './style.css';
import {css,cx} from "emotion";
import {CancellationToken} from "../../shared/utilities/ajax/WPApiPost";
import {SpinnerButton} from "../../shared/controls/SpinnerButton";
import {WpAjaxPost} from "../../shared/utilities/ajax/WPAjaxPost";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {FormPicker} from "./pagebuilder/Dialogs/FormPicker";
import {ToastService} from "shared/utilities/services/ToastService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {TemplateSettings} from "./Dialogs/TemplateSettings";
import {PageService} from "PageBuilder/pagebuilder/services/PageService";
import {PDFDocumentOptions} from "PageBuilder/pagebuilder/PDFDocument.Options";
import {TemplateManagerDialog} from "PageBuilder/Dialogs/TemplateManager/TemplateManagerDialog";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";

library.add(faTimes);
export class App extends React.Component<any,AppState> {
    public loading: boolean = false;
//  public previewSettingsDialog:BasicDialog;
    public cancelToken:CancellationToken;

    public $validatingOrder: JQuery;
    public $invalidOrder: JQuery;
    public $validOrder: JQuery;
    public currentInputValidationStatus: InputValidationStatus = null;
    public ProBootstrap: any = null;
    public builder: Builder;
    public pageService: any;
    public IsPr = (window as any).rednaoVar.IsPr;
    public previewSettingsDialog:any;

    // public pageService:PageService;


    constructor(props: any, context: any/*public pageService:PageService*/) {
        super(props, context);
        this.pageService=PageService.Instance();
        this.Export = this.Export.bind(this);
        (window as any).Export = this.Export;
        this.state={
            IsBusy:false,
            Text:''
        };

        WpAjaxPost.SetGlobalVar(rednaoVar);

    }


    componentDidMount(): void {
        this.load();
    }

    public IsDevMode() {
        return true;
    }

    public render() {
        return(
            <div className={"rednao"} style={{width: '100%', height: '100%'}}>
                {rednaoVar.IsPr == '' &&
                <div className="bootstrap-wrapper">
                    <div className="alert alert-info" style={{margin:0}}><span className="fa fa-diamond"/><strong>More templates, Printer Support, Front end download, Google Drive Integration, Bulk Actions and much more. <a
                            target="_blank"
                            href={rednaoVar.PurchaseURL}>Get
                            the full version now</a></strong></div>
                </div>
                }
                <div style={{width: '100%', height: '100%'}}>
                    <div className="mainButtonToolbar" style={{height: 70, padding: 10,display:'flex'}}>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <SpinnerButton IsBusy={this.state.IsBusy}
                                           OnClick={() => this.SaveClicked()}>Save</SpinnerButton>

                            <button onClick={() => this.OpenSettings()} style={{marginLeft: 5}}
                                    className="rnbtn rnbtn-primary">
                                <FontAwesomeIcon icon={faCog}/> Template Settings
                            </button>

                            <button style={{marginLeft: 5}} onClick={() => this.ExecutePreview()}
                                    className="rnbtn rnbtn-info">
                                <FontAwesomeIcon icon={faSearch}/> Preview
                            </button>
                        </div>
                        <div style={{display: 'inline-flex', flexGrow: 1, alignItems: 'center', margin: '0 10px'}}>
                            <h4 style={{margin: '0 0 0 15px', display: 'inline-block'}}>Editing: </h4>
                            <input id="smartFormName" placeholder={'Please define a name for your template'} className={css`{
                                                                      background-color: transparent;
                                                                      border:1px solid transparent;
                                                                      font-weight: bold;
                                                                      font-size:30px;
                                                                      &:hover{
                                                                        border:#007cba 1px solid;
                                                                      }
                                                                    }`}
                                   style={{width: 400, cursor: 'pointer', backgroundColor: 'transparent', flexGrow: 1}}
                                   value={this.state.Text} onChange={e=>{this.setState({Text:e.target.value});this.builder.page.PageOptions.Name=e.target.value;}}/>
                        </div>


                        <a
                            href={rednaoVar.AdminUrl}
                            id={'ExitButton'}
                            className={css`{
                                color:black;
                                cursor:pointer;
                                transition:200ms color ease-in-out;
                                &:hover{
                                  color:red;
                                }

                              }`}
                            style={{fontSize: 30, float: 'right',display:'flex',alignItems:'center'}}><FontAwesomeIcon icon={"times"}/></a>

                    </div>
                    <Builder ref={(node) => this.builder = node}/>

                </div>
            </div>
        );
    }




    async SaveClicked() {
           this.setState({IsBusy:true});
           let result=await WpAjaxPost.Post<{id:number}>('save_template',this.builder.page.GetPageOptionsToSave());
           console.log(result);
           if(result!=null) {
               if(this.builder.page.PageOptions.Id==0)
               {
                   history.pushState(null, null, window.location.href.toLowerCase().replace('template_id=0','template_id='+result.id));
               }
               this.builder.page.PageOptions.Id = result.id;
               ToastService.SendSuccess('Template saved successfully');
           }


           this.setState({IsBusy:false});
    }

    public async Save(): Promise<void> {
        return null;
    }

    ExecutePreview() {
            this.pageService.ExecutePreview();
    }

    OpenSettings() {
          Dialog.Show(<TemplateSettings Options={this.builder.page.PageOptions} Page={this.builder.page}/>)
    }

    PreviewSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        if(this.previewSettingsDialog==null)
        {
            this.previewSettingsDialog=new BasicDialog();
            this.previewSettingsDialog.SetTitle('Preview Settings');
            this.previewSettingsDialog.HideCancelButton();
            this.previewSettingsDialog.SetAcceptButtonText('Done');
            let $content=jQuery(
                `<div>
                     <label>What date do you want to preview</label>
                     <select class="form-control" id="dataToUseInPreview">
                         <option value="fake">Use fake data</option>
                         <option value="orderNumber">Use a real order</option>
                     </select>
                     <div style="padding-top:20px;overflow:hidden;display: none;" id="orderNumberContainer" >
                         <label>Which order number do you want to use?</label>
                         <div style="position: relative">
                             <input placeholder="Order Number" style="width:100%" class="form-control" multiple="multiple" id="orderNumber">
                             <div style="position:absolute;top:50%;right:2px;transform:translateY(-50%);">
                                 <span class="orderNumberValidationStatus validatingOrder" style="color:#9f9f9f;display: none;opacity:0;">Validating Order <span style="color:black;" class="fa fa-spinner fa-spin"></span></span>
                                 <span class="orderNumberValidationStatus orderIsValid" style="color:#9f9f9f;display: none;opacity:0">Order is valid <span style="color:green;" class="fa fa-check""></span></span>
                                 <span class="orderNumberValidationStatus orderIsInvalid" style="color:#9f9f9f;display: none;opacity:0"><span class="invalidOrderMessage">Invalid Order! </span> <span style="color:red;" class="fa fa-times""></span></span>
                             </div>
                         </div>
                     </div>
                 </div>
                     `
            );

            let $orderNumberContainer=$content.find('#orderNumberContainer');
            let height=0;
            $content.find('#dataToUseInPreview').change((e)=>{
                this.pageService.previewType=jQuery(e.target).val() as any;
                if(this.pageService.previewType=="orderNumber")
                {
                    if(height==0)
                    {
                        $orderNumberContainer.css('position','absolute');
                        $orderNumberContainer.css('opacity',0);
                        $orderNumberContainer.css('display','block');
                        height=$orderNumberContainer.outerHeight();
                        $orderNumberContainer.css('height',0);
                        $orderNumberContainer.css('position','static');
                        $orderNumberContainer.css('opacity','1');
                    }

                    $orderNumberContainer.css('display','block');
                    $orderNumberContainer.velocity({height:height},200,'easeInExp');

                }

            });


            $content.find('#orderNumber').on('input',()=>this.PreviewOrderChanged());

            this.$validatingOrder=$content.find('.validatingOrder');
            this.$invalidOrder=$content.find('.orderIsInvalid');
            this.$validOrder=$content.find('.orderIsValid');
            this.previewSettingsDialog.SetContent($content);
        }
        this.previewSettingsDialog.Show();

    }

    private async PreviewOrderChanged() {
        let orderNumber=this.previewSettingsDialog.$Dialog.find('#orderNumber').val().toString();
        if(this.cancelToken!=null) {
            this.cancelToken.Cancel();
            this.cancelToken=null;
        }
        if(orderNumber=='')
        {
            this.ChangePreviewOrderInputStatus(null);
            this.pageService.orderNumberToPreview=null;
            return;
        }
        this.ChangePreviewOrderInputStatus('validating');
        let result =await WpAjaxPost.CancellablePost<any>('rednao_check_if_order_is_valid',{OrderNumber:orderNumber},this.cancelToken=new CancellationToken(),{ReturnError:true});
        if(result.wasCancelled)
            return;
        if(!result.wasCancelled&&result.result=='success') {
            this.ChangePreviewOrderInputStatus("valid");
            this.pageService.orderNumberToPreview=parseInt(orderNumber);
        }
        else {
            this.ChangePreviewOrderInputStatus("invalid", result.result.errorMessage);
            this.pageService.orderNumberToPreview=null;
        }




    }










     private async ChangePreviewOrderInputStatus(validationStatus: InputValidationStatus,message:string='') {
         if(validationStatus==this.currentInputValidationStatus)
             return;

         if(this.currentInputValidationStatus!=null)
         {
             await this.previewSettingsDialog.$Dialog.find('.orderNumberValidationStatus').velocityAsync({opacity:0},200,'easeOutExp');
             this.previewSettingsDialog.$Dialog.find('.orderNumberValidationStatus').css('display','none');
         }

         this.currentInputValidationStatus=validationStatus;
         if(validationStatus!=null) {
             let $elementToShow: JQuery;
             switch (validationStatus) {
                 case "invalid":
                     this.previewSettingsDialog.$Dialog.find('.invalidOrderMessage').text(message);
                     $elementToShow = this.$invalidOrder;
                     break;
                 case "valid":
                     $elementToShow = this.$validOrder;
                     break;
                 case "validating":
                     $elementToShow = this.$validatingOrder;

                     break;
                 default:
                     return;
             }

             $elementToShow.css('display', 'block');
             $elementToShow.velocity({opacity: 1}, 200, 'easeInExp');
         }

     }



    async load() {

        for(let form of rednaoVar.FormList)
        {
            try {
                form.Fields = JSON.parse(form.Fields);

                if(form.Notifications.toString().trim()!='')
                    form.Notifications=JSON.parse(form.Notifications as any);
                else
                    form.Notifications=[];
            }catch(E)
            {
                form.Fields=[] as any;
            }
        }
        if(rednaoVar.TemplateData!=null)
        {
            rednaoVar.TemplateData.DocumentSettings=JSON.parse(rednaoVar.TemplateData.DocumentSettings as any);
            rednaoVar.TemplateData.Pages=JSON.parse(rednaoVar.TemplateData.Pages as any);

            let documentOptions=new PDFDocumentOptions().Merge(rednaoVar.TemplateData);
            if(documentOptions.DocumentSettings.CreatedFromTemplate)
            {
                documentOptions=await Dialog.Show(<TemplateManagerDialog DocumentOptions={documentOptions}/>);

                if(documentOptions==null)
                    document.location.href=rednaoVar.AdminUrl;

            }

            let form=rednaoVar.FormList.find(x=>x.Id==documentOptions.FormId);

            this.builder.load(form as any,documentOptions);
            this.setState({Text:documentOptions.Name});
            return;
        }else{
            this.setState({Text:'New Form'});
        }


        let selectedForm=await Dialog.Show(<FormPicker/>);
        if(selectedForm==null)
            document.location.href=rednaoVar.AdminUrl;
        else {
            this.builder.load(selectedForm.Form,selectedForm.TemplateData);
            this.setState({Text:selectedForm.TemplateData?selectedForm.TemplateData.Name:''});
        }
    }

    Export() {
        let $form = jQuery(`<form style="display: none" enctype="multipart/form-data" method="post" target="_blank" action="${(window as any).ajaxurl}">
                                <input name="action" type="hidden" value="rednao_wcpdfinv_get_designer_export"/>
                                <input name="data" type="hidden"  value="" class="json" />
                                <input name="pageId" type="hidden"  value="${this.pageService.page.PageOptions.pageId}" class="json" />
                                <button></button>
                           </form>                           
                        `);
        jQuery('body').append($form);
        $form.submit();
    }

}

export type InputValidationStatus = 'validating' | 'valid' | 'invalid';

declare let rednaoPDFInvoiceParams:any;

interface AppState {
    IsBusy:boolean;
    Text:string;

}